import { CheckIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  useColorModeValue
} from "@chakra-ui/react";
import { Project, ProjectCategory } from "models/project_type";
import { useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import InputMask from "react-input-mask";
import formatNumber from "views/admin/order/hooks/formatNumber";
import FinanceProjectCategory from "./FinanceCategory";

interface IFormFinanceProject {
  showModal: (show: boolean, item: Project) => void;
  show: boolean;
  accountSelected: Project;
  loading: boolean;
  save: () => void;
  changeItem: (item: ProjectCategory) => void;
  changeProject: (value: string, type: string, item: Project) => void;
  showModalApprove: (show: boolean) => void
}

const FormFinanceProject = ({
  show,
  showModal,
  accountSelected,
  loading,
  save,
  changeItem,
  changeProject,
  showModalApprove
}: IFormFinanceProject) => {
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const [dif, setDif] = useState(0);
  const [manejo, setManejo] = useState(0);
  const [total, setTotal] = useState(0);
  const [economia, setEconomia] = useState(0);
  const [valorProdutor, setValorProdutor] = useState(0);


  const lockItem = (item: ProjectCategory) => {
    const lock = !item.travado;
    const categ = accountSelected?.Orcamento?.OrcamentoCategoria?.find(
      (ca) => ca.descricao === item.descricao
    );
    item.travado = lock;
    let soma = 0;
    item.ProjetoItem = item.ProjetoItem.map((pr) => {
      if (lock) {
        const defaultItem = categ.OrcamentoItem?.find(
          (ct) => ct.produtoId === pr.produtoId
        );
        pr.valorUn = defaultItem.valorUn;
        pr.valorTotal = defaultItem.valorTotal;
        pr.valorReducao = "0";
        pr.porcentagemReducao = "00.00";
        pr.valorManejo = "0";
        pr.porcentagemManejo = "00.00";
      }
      pr.travado = lock;
      soma += Number(pr.valorTotal);
      return pr;
    });
    item.valorReducao = "0";
    item.porcentagemReducao = "00.00";
    item.valorManejo = "0";
    item.porcentagemManejo = "00.00";
    item.valor = Number(soma);
    changeItem(item);
  };

  const calcula = () => {
    const soma = accountSelected.ProjetoCategoria.reduce(
      (acc, pr) => acc + Number(pr.valorReducao),
      0
    );
    const itemTotal = accountSelected.ProjetoCategoria.reduce(
      (acc, pr) => acc + Number(pr.valor),
      0
    );
    changeProject(soma.toString(), 'valorReduzido', accountSelected);
    setDif(soma);
    setTotal(itemTotal);
  };

  const calculaManejo = () => {
    const soma = accountSelected.ProjetoCategoria.reduce(
      (acc, pr) => acc + Number(pr.valorManejo),
      0
    );
    changeProject(soma.toString(), 'valorManejo', accountSelected);
    setManejo(soma);
  };

  const changeReducaoGlobal = (value: string) => {
    changeProject(value, 'reducaoGlobal', accountSelected);
    // @ts-ignore
    accountSelected?.ProjetoCategoria?.map((item) => {
      reducaoGrupo(item, value);
      return null;
    });
  };

  const changeManejo = (value: string) => {
    changeProject(value, 'limiteManejo', accountSelected);
    // @ts-ignore
    accountSelected?.ProjetoCategoria?.map((ac) => {
      manejoGrupo(ac, value);
      return null;
    });
  };
  const reducaoGrupo = (item: ProjectCategory, value: string) => {
    if (item.travado) {
      return;
    }

    const val = Number(value);
    const categ = accountSelected?.Orcamento?.OrcamentoCategoria?.find(
      (ca) => ca.descricao === item.descricao
    );

    item.porcentagemReducao = value;
    item.valorReducao = Number((categ.valor * val) / 100).toString();

    let soma = 0;

    item.ProjetoItem = item.ProjetoItem.map((b) => {
      const defaultItem = categ.OrcamentoItem?.find(
        (ct) => ct.produtoId === b.produtoId
      );

      if (!b.travado) {
        b.valorUn = defaultItem.valorUn - (defaultItem.valorUn * val) / 100;
        b.valorTotal =
          defaultItem.valorTotal - (defaultItem.valorTotal * val) / 100;
        b.valorReducao = (defaultItem.valorTotal - b.valorTotal).toFixed();
        b.porcentagemReducao = value;
      } else {
        b.valorUn = defaultItem.valorUn;
        b.valorTotal = defaultItem.valorTotal;
      }

      soma += b.valorTotal;
      return b;
    });

    item.valor = Number(soma);

    changeItem(item);
    manejoGrupo(item, item.porcentagemManejo);
    calcula();
  };

  const manejoGrupo = (item: ProjectCategory, value: string) => {
    const val = Number(value);
    item.porcentagemManejo = value;
    item.valorManejo = Number((item.valor * val) / 100).toString();
    item.ProjetoItem = item.ProjetoItem.map((pr) => {
      pr.porcentagemManejo = value;
      pr.valorManejo = Number((pr.valorTotal * val) / 100).toString();
      return pr;
    });
    changeItem(item);
    calculaManejo();
    calcula();
  };

  const changeEconomia = (value: string) => {

    changeProject(value, 'metaEconomia', accountSelected);
    const val = Number(value);
    const valorEco = (total * val) / 100;
    setEconomia(valorEco);
    changeProject(valorEco.toString(), 'valorEconomia', accountSelected);
  };

  const changePercentualProdutor = (value: string) => {
    changeProject(value, 'percentualProdutor', accountSelected);
    const val = Number(value);
    const valorProdutor = (economia * val) / 100;
    setValorProdutor(valorProdutor);
    changeProject(valorProdutor.toString(), 'retornoProdutor', accountSelected);
  };

  useEffect(() => {

    if (accountSelected) {
      setTotal(Number(accountSelected?.Orcamento?.total) - Number(accountSelected?.valorReduzido));
      setDif(Number(accountSelected?.valorReduzido));
      setManejo(Number(accountSelected?.valorManejo));
      setEconomia(Number(accountSelected?.valorEconomia));
      setValorProdutor(Number(accountSelected?.retornoProdutor));
    }
  }, [accountSelected]);

  return (
    <Box >
      <Box>
        <Box>
          <Box
            px="0px"
            mb="16px"
            mt="0px"
            justifyContent="space-between"
            ml={4}
          >
            <Text
              fontWeight={"black"}
              color={"red.600"}
              fontSize={20}
              mb={4}
              mr={4}
              alignSelf={"flex-end"}
              float={"right"}
            >
              Total de Verba Alocada :&nbsp;
              {formatNumber(Number(accountSelected?.Orcamento?.total))}
            </Text>
            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdSave />}
                colorScheme="brand"
                size={"sm"}
                ml={2}
                variant="solid"
                isLoading={loading}
                onClick={() => {
                  save();
                }}
              >
                Salvar
              </Button>

              <Button
                leftIcon={<CheckIcon />}
                colorScheme="brand"
                size={"sm"}
                onClick={() => {
                  showModalApprove(true);
                }}
                variant="solid"
              >
                Aprovar
              </Button>
            </Stack>
          </Box>
        </Box>

        <Text
          mt={32}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Itens do Orçamento
        </Text>

        <SimpleGrid columns={4} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}

              mb="8px"
            >
              Redução Global (%)
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Redução Global (%)"
              fontWeight="500"
              size="md"
              defaultValue={Number(accountSelected?.reducaoGloblal).toFixed(4)}
              onBlur={(e) => changeReducaoGlobal(e.target.value)}
              as={InputMask}
              mask={"99.99"}
              disabled={false}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Valor Reduzido
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Valor Reduzido"
              fontWeight="500"
              size="md"
              value={formatNumber(Number(dif))}
              disabled={true}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Limite de Manejo (%)
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Limite de Manejo (%)"
              fontWeight="500"
              size="md"
              defaultValue={Number(accountSelected?.limiteManejo)?.toFixed(4)}
              onBlur={(e) => {
                changeManejo(e.target.value);
              }}
              as={InputMask}
              mask={"99.99"}
              disabled={false}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Valor Manejado
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Valor Manejado"
              fontWeight="500"
              value={formatNumber(Number(manejo))}
              size="md"
              disabled={true}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Meta de Economia
        </Text>

        <SimpleGrid columns={5} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Verba Total
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" Verba Total"
              fontWeight="500"
              size="md"
              value={formatNumber(Number(total))}
              disabled={true}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Taxa de Economia (%)
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Taxa de Economia (%)"
              fontWeight="500"
              defaultValue={Number(accountSelected?.metaEconomia).toFixed(4)}
              onBlur={(e) => {
                changeEconomia(e.target.value);
              }}
              size="md"
              as={InputMask}
              mask={"99.99"}
              disabled={false}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Valor Economia
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Valor Reduzido"
              fontWeight="500"
              size="md"
              value={formatNumber(Number(economia))}
              disabled={true}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Percentual do Produtor
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Percentual do Produtor"
              fontWeight="500"
              defaultValue={Number(accountSelected?.percentualProdutor).toFixed(4)}
              onBlur={(e) => {
                changePercentualProdutor(e.target.value);
              }}
              as={InputMask}
              mask={"99.99"}
              size="md"
              disabled={false}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
              mb="8px"
            >
              Retorno Produtor
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Valor Reduzido"
              fontWeight="500"
              value={formatNumber(Number(valorProdutor))}
              size="md"
              disabled={true}
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid column={1} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mt={4}
              color={"black"}
            >
              Instruções sobre Meta de Economia
            </FormLabel>
            <Textarea
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="área de texto com instruções referentes a meta de economia"
              onBlur={(e) => {
                changeProject(e.target.value, 'taxaEconomia', accountSelected)
              }}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid spacing={4} mt={12}>
          {accountSelected?.ProjetoCategoria?.map((item, index) => (
            <FinanceProjectCategory
              borderColor={borderColor}
              changeItem={changeItem}
              index={index}
              item={item}
              lockItem={lockItem}
              manejoGrupo={manejoGrupo}
              reducaoGrupo={reducaoGrupo}
              accountSelected={accountSelected}
              calcula={calcula}
              calculaManejo={calculaManejo}
            />
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};
export default FormFinanceProject;
